import { HelperContext } from "../../Helper/helper.context";
import { helpContextResponsive } from "../../Helper/utils";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import ImgHelpForecastAgg1 from '../../../images/help_context/precipitation_aggregation_1.png';
import ImgHelpForecastAgg2 from '../../../images/help_context/precipitation_aggregation_2.png';

export const ForecastAggHelpContext = ({onClose}) => {
    return (
        <HelperContext 
        onClose={onClose}
        children={
            <div className="pos-relative">
            <Carousel 
                    className="help-context-carousel"            
                responsive={helpContextResponsive}
            >
                <div className="help-context-item">
                    <img src={ImgHelpForecastAgg1}/>
                </div>
                <div className="help-context-item">
                    <img src={ImgHelpForecastAgg2}/>
                </div>
            </Carousel>
        </div>
}
    />    
)}